import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

export const StyledSwipeableDrawer = styled(SwipeableDrawer)(
  ({ theme }) => css`
    .MuiDrawer-paper {
      border-radius: 16px 16px 0px 0px;
      box-shadow: 0px 0px 100px 0px rgba(0, 0, 0, 0.15);
      padding-top: 32px;
      gap: 8px;

      .ui-drawer-header {
        display: flex;
        justify-content: space-between;
        align-items: start;
        margin: 0 16px 16px;
        color: ${theme.palette.secondary.moreLight};
      }

      .ui-drawer-title {
        display: flex;
        align-items: center;
        gap: 16px;

        span {
          font-size: ${theme.typography.subtitleBold.fontSize};
          font-weight: ${theme.typography.subtitleBold.fontWeight};
          line-height: ${theme.typography.subtitleBold.lineHeight};
        }
      }
    }
  `
);
